module.exports = __webpack_public_path__ + "components/MapControl/svg/Ruiny.svg?91329341";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Ruiny.svg
// module id = 2055
// module chunks = 0